export const NAVIGATION_START_TIMEOUT = 1_000;
export const NAVIGATION_END_TIMEOUT = 10_000;

/**
 * How long a settled continuation waits for the preview iframe to reach
 * `ready` before giving up. A follow-up turn captures page HTML, so firing
 * into a non-ready page risks shipping a stale cached snapshot — we defer
 * until ready, then abort so a stuck page doesn't lock the chat forever.
 */
export const PAGE_READY_TIMEOUT = 15_000;

/**
 * Backstop on awaiting a turn's terminal (`finish`) event. The server emits
 * `finish` right after a stopOnCall tool, so this is only ever hit if the
 * stream dies without one — in which case we treat the turn as aborted.
 */
export const CONTINUATION_TERMINAL_TIMEOUT = 30_000;

/**
 * Max number of auto-verify rounds per user turn cycle. The AI can request
 * another verification after a correction via `update_mods({ verify: true })`.
 * Cap exists to prevent runaway loops when the AI can't converge; 5 gives
 * room for several apply→verify→correct iterations without risking infinite
 * loops, which covers harder cases (e.g. text/HTML mode swaps, insert-type
 * retries) that 3 attempts wasn't reliably finishing.
 */
export const MAX_AUTO_VERIFY_ATTEMPTS = 5;
